import React from "react";
import settings from "../../../settings";
import { Frame, Heading } from "./styles";

interface Props {
	onClick?: () => void;
	className?: string;
}
const Arrow: React.FC = () => {
	return (
		<svg width="24" height="99">
			<path
				d="M 2 2.5 L 2 96.851 L 22 76.851"
				fill="transparent"
				strokeWidth="3"
				stroke={settings.color.accent}
				strokeMiterlimit="10"
				strokeDasharray=""
				data-projection-id="2"
			></path>
		</svg>
	);
};

const ScrollSuggest: React.FC<Props> = (props) => {
	const { onClick, className } = props;
	return (
		<Frame className={className} onClick={onClick}>
			<Arrow />
			<Heading>SCROLL</Heading>
		</Frame>
	);
};

export default ScrollSuggest;
